<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.gapReverse"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.gapReverse"].value;
});
</script>

<template>
  <!-- 不设置 width height , 自适应父元素 -->
  <!-- origin viewBox : x y width height, 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M9.71952 17.7046C9.32618 18.0985 8.68844 18.0985 8.2951 17.7046C7.90176 17.3108 7.90176 16.6723 8.2951 16.2785L14.2806 11.2869C14.6739 10.8931 15.3116 10.8931 15.705 11.2869C16.0983 11.6807 16.0983 12.3193 15.705 12.7131L9.71952 17.7046Z"
      :fill="color"
    />
    <path
      d="M8.29501 7.72152C7.90166 7.3277 7.90166 6.68919 8.29501 6.29537C8.68835 5.90154 9.32609 5.90154 9.71943 6.29537L15.705 11.2869C16.0983 11.6807 16.0983 12.3193 15.705 12.7131C15.3116 13.1069 14.6738 13.1069 14.2805 12.7131L8.29501 7.72152Z"
      :fill="color"
    />
  </svg>
</template>
